<template>
    <div class="Focus">
        <custList :sysBoxValue="sysBoxValue"></custList>
    </div>
</template>
<script>
import custList from './custList/index.vue'
import titleMixin from '@/mixin/title'
export default {
    name: 'Focus',
    title: '查重',
    mixins: [titleMixin],
    props: {
        sysBoxValue: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            msg: 'Focus',
            pageUrl: ''
        }
    },
    created() {
        this.$options.title = this.$t('mx_mobile.Client.1585113135487') // 查重
    },
    mounted() {
        this.pageUrl = this.$route.path
    },
    methods: {
    },
    watch: {
        '$route': function (val, old) {
        }
    },
    beforeRouteLeave(to, from, next) {
        const flag = this.Global.utils.chosen.close()
        const flag2 = this.Global.utils.actionSheet.close()
        const flag3 = this.Global.utils.prompt.close()
        if (flag || flag2 || flag3) {
            next(false)
        } else {
            next()
        }
    },
    components: {
        'custList': custList
    }
}
</script>

<style lang="less" scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
